import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class CustomFieldsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'CustomFieldsConfiguration';
  nodataLocalizationKeyName = 'customFields';
  readonly reportSection = ReportSection.CustomFields;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_CustomFields];
  minSize = 1;
  maxSize = 4;
  defaultSize = 4;

  get availableDataSections(): ReportSectionDataSection[] {
    // TODO: Implement getting custom fields from the API
    const customFields: ReportSectionDataSection[] = [];
    return customFields;
  }

  get name(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'contactCustomFields';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionCustomFields';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact || this.appliedReportType === ReportType.Institution) {
      return 'Custom Fields';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface Associations {
  gridAssociations: Association[];
  textAssociations: Association[];
  customFields: Association[];
}

export interface Association {
  name: string;
  value: string;
  type?: string;
}

export interface CustomFieldData {
  [ReportViewModelSection.InvestorProfile_CustomFields]: Associations;
}
